<script setup lang="ts">
import { Button } from "@toruslabs/vue-components/Button";

import IconBack from "../../assets/claim/icon-back.svg";
import MocaIconError from "../../assets/claim/moca-icon-error.svg";
import MetamaskLoginFactory from "../../handlers/Auth/MetamaskFactory";
import { useClaimStore } from "../../store/claimStore";
import { useControllerStore } from "../../store/controllerStore";

const emit = defineEmits(["on-retry"]);
const claimStore = useClaimStore();
const controllerStore = useControllerStore();

async function onBack() {
  const metamask = await MetamaskLoginFactory.getInstance({
    providerConfig: controllerStore.networkProviderConfig,
    onLogout: controllerStore.logout,
  });
  if (metamask.connnected) {
    metamask.disconnect();
  }
  claimStore.mocaNFTAddress = "";
  claimStore.mocaSignature = "";
  claimStore.showClaimMethods();
}
</script>

<template>
  <Button class="mb-2 !text-moca-gray-3 !text-sm !font-semibold !bg-moca-transparent !px-0" @on-click="() => onBack()">
    <img :src="IconBack" class="w-4" />
    <p>Back</p>
  </Button>
  <div class="flex flex-col items-center justify-center gap-6 tab:min-h-[400px]">
    <p class="text-moca-error-red text-2xl font-bold">Request Rejected</p>
    <img :src="MocaIconError" class="w-16 h-16" />
    <p class="text-moca-white-80 text-base font-semibold text-center">Seems like you rejected the signature request. Please try again.</p>
    <Button
      class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !w-48 !rounded-full !px-6"
      @on-click="() => emit('on-retry')"
    >
      Retry
    </Button>
  </div>
</template>
